import _ from 'underscore';

angular.module('am4')
.factory('appCacheService', function() {
    var initial = {
        // app state
            appState: {
                firstLoad: true,
                filtersCollapsed: false,
                activeMachinesOnly: true,
                deleted: false,
                sort: {
                    facet: 'frame_serial',
                    descending: false
                },

                // Persist the unsaved (not in a filter)
                // dashboard options
                dashboardOptions: {
                    machine_type_code: [],
                    series: [],
                    facility_id: [],
                    organization_id: [],
                    status: []
                },

                // Put ANY (filter or dashboard) options
                // here. Never load back into the elastic list.
                // This is for other controllers (like 'generate
                // report') to see the current dashboard state
                // at any time
                currentElasticOptions: {
                    machine_type_code: [],
                    series: [],
                    facility_id: [],
                    organization_id: [],
                    status: []
                },

                // Report state
                report: {
                    interval: 'daily',
                    type: null,
                    start: null,
                    end: null,
                    resolution: '60',
                    groups: [],
                    groupOptions: ['machine_type_code', 'series']
                }
            },
            // error service
            errorList: [],

            // filter service
            filters: {
                refreshNeeded: true
            },

            // machine service
            dataStore: {
                invalidateAfter: {},
                machineData: {
                    machines: []
                }
            },

            // org facility service
            organizationsDictionary: undefined,
            facilitiesDictionary: undefined,

            // workout data service
            workoutDataStore: {}
        },
        appCache = angular.copy(initial);

    return {
        getAppCache: function(param) {
            return appCache[param];
        },
        setAppCache: function(param, newState) {
            appCache[param] = newState;
        },
        clearCache: function() {
            appCache = angular.copy(initial);
        },
        updateCachedMachine: function(frameSerial, property, newValue) {
            // only need to update if data already cached. otherwise will fetch correctly
            if (appCache.dataStore.machineData.machines.length) {
                var idx = _.findIndex(appCache.dataStore.machineData.machines, function(mach) {
                    return mach.frame_serial === frameSerial;
                });
                appCache.dataStore.machineData.machines[idx][property] = newValue;
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/appCache.js